import React from 'react';

export interface FacebookProps {
  className?: string;
}

const WeatherFire: React.FC<FacebookProps> = ({ className }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 18.5C24 23.7467 19.7467 28 14.5 28C9.25329 28 5 23.7467 5 18.5C5 15.9206 6 14 7.5 12.5C6.5 15.5 8.3777 20.3112 12 18.5C14 17.5 13.705 15.2147 12.6827 13.5C10 9 13 3.5 17 2C15 13.5 24 11.5 24 18.5Z"
        stroke="white"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default WeatherFire;
